export const SERVICE_DETAIL_OVERRIDES = {
  separatdienst: {
    lead:
      "Präsenzstarker Sicherheitsdienst für sensible Zonen, Empfangsbereiche und Kundenflächen mit klarer Ansprache und ruhigem Auftreten.",
    bullets: [
      "sichtbare Präsenz zur Prävention von Vorfällen",
      "kontrollierte Abläufe in frequentierten Bereichen",
      "dokumentierte Beobachtungen und direkte Ansprechpartner vor Ort",
    ],
    suitableFor: "Einzelhandel, Foyers, sensible Gewerbeflächen und publikumsintensive Standorte.",
  },
  revierdienst: {
    lead:
      "Mobile Kontrollfahrten und definierte Schließ- oder Prüfroutinen für Objekte, Areale und Außenflächen.",
    bullets: [
      "regelmäßige Kontrollgänge nach definiertem Intervall",
      "Tür-, Tor- und Fensterroutinen mit Meldung auffälliger Ereignisse",
      "schnelle Reaktion bei Auffälligkeiten oder Alarmen",
    ],
    suitableFor: "Bürogebäude, Gewerbeeinheiten, Baustellen, Wohnanlagen und Industriegelände.",
  },
  centersecurity: {
    lead:
      "Sicherheit und Service für Einkaufszentren, Passagen und gemischt genutzte Immobilien mit hohem Publikumsverkehr.",
    bullets: [
      "sichtbare Präsenz und Besucherlenkung",
      "Unterstützung von Mietern, Management und Besuchern",
      "deeskalierende Ansprache bei Konflikten oder Störungen",
    ],
    suitableFor: "Center, Fachmarktzentren, Passagen und große Handelsflächen.",
  },
  empfangsdienst: {
    lead:
      "Verlässlicher Empfangsservice mit Sicherheitsfokus, Besuchersteuerung und einem professionellen ersten Eindruck.",
  },
  personenschutz: {
    lead:
      "Diskreter, strukturierter Personenschutz für Einzelpersonen, Führungskräfte und besondere Anlässe mit erhöhtem Sicherheitsbedarf.",
  },
  interventionsdienst: {
    lead:
      "Koordinierte Intervention bei Alarmen, Auffälligkeiten oder sicherheitsrelevanten Vorfällen im Raum Hannover.",
  },
  videoueberwachung: {
    lead:
      "Moderne visuelle Objektüberwachung zur Ergänzung von Präsenzkräften und geregelten Eskalationswegen.",
  },
  baustellenbewachung: {
    lead:
      "Kontrollierte Baustellensicherheit zum Schutz von Material, Maschinen, Zufahrten und sensiblen Bauabschnitten.",
  },
  "objekt-und-werkschutz": {
    lead:
      "Ganzheitlicher Schutz von Gebäuden, Produktionsstandorten und Firmengeländen mit kontrollierten Zugängen und festen Sicherheitsabläufen.",
  },
};
